import * as orders from "./orders";

export const dshop = {
    ...orders
}